import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function ImagePreviewDialog({ selectedImagePreview, onClose }) {
  if (!selectedImagePreview) return null;

  return (
    <Dialog
      open={!!selectedImagePreview}
      onOpenChange={onClose}
      style={{ zIndex: 9999 }}
    >
      <DialogContent
        className="max-w-4xl w-auto p-0 bg-black/90 border-zinc-800 rounded-2xl overflow-hidden"
        style={{ zIndex: 9999 }}
        hideCloseButton={true}
      >
        <DialogHeader className="sr-only">
          <DialogTitle>Image Preview</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center">
          <img
            src={selectedImagePreview.url}
            alt={selectedImagePreview.name}
            className="max-w-full max-h-[80vh] object-contain rounded-2xl"
            onError={(e) => {
              console.error(
                "Large image failed to load:",
                selectedImagePreview.url
              );
              onClose();
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
